import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ReactComponent as LeftIcon } from './icons/leftIcon.svg';
import { ReactComponent as RightIcon } from './icons/rightIcon.svg';

import styles from './Modal.module.css';

const CustomLeftArrow = ({ onClick }) => (
    <button
        className={`${styles.carouselArrow} ${styles.carouselArrowLeft}`}
        onClick={onClick}
    >
        <LeftIcon />
    </button>
);

const CustomRightArrow = ({ onClick }) => (
    <button
        className={`${styles.carouselArrow} ${styles.carouselArrowRight}`}
        onClick={onClick}
    >
        <RightIcon />
    </button>
);

const Slider = ({ images, videos }) => {
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    const mediaItems = [...(videos || []), ...(images || [])];

    return (
        <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={false}
            autoPlaySpeed={3000}
            arrows
            ssr
            draggable
            showDots
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
        >
            {mediaItems.map((item, index) => (
                <div key={index} className={styles.sliderImageContainer}>
                    {item.endsWith('.mp4') ? (
                        <video
                            controls
                            className={`${styles.sliderVideo} ${
                                item.includes('vertical') ? styles.vertical : ''
                            }`}
                            autoPlay
                        >
                            <source src={item} type='video/mp4' />
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <img
                            src={item}
                            alt={`slide-${index}`}
                            className={styles.sliderImage}
                        />
                    )}
                </div>
            ))}
        </Carousel>
    );
};

export default Slider;
